export default "__VITE_ASSET__6e892dbf__"